import React from "react";

/** Clickable SVG candlestick strip for mission interactions (precise click targets). */
export default function CandlePick({ candles, onPick, disabled, correctIndex, pickedIndex }) {
  if (!candles?.length) return null;
  const W = 640, H = 260, pad = 20;
  const highs = candles.map((c) => c.high), lows = candles.map((c) => c.low);
  const max = Math.max(...highs), min = Math.min(...lows);
  const range = max - min || 1;
  const slot = (W - pad * 2) / candles.length;
  const bodyW = slot * 0.55;
  const y = (p) => pad + (H - pad * 2) * (1 - (p - min) / range);

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full rounded-lg border border-white/10 bg-[#0A0E16]" data-testid="candle-pick">
      {candles.map((c, i) => {
        const cx = pad + slot * i + slot / 2;
        const up = c.close >= c.open;
        const base = up ? "#10B981" : "#EF4444";
        const isCorrect = correctIndex === i;
        const isPicked = pickedIndex === i;
        const color = isCorrect ? "#10B981" : isPicked && !isCorrect ? "#EF4444" : base;
        return (
          <g key={i} onClick={() => !disabled && onPick?.(i)} style={{ cursor: disabled ? "default" : "pointer" }} data-testid={`candle-${i}`}>
            <rect x={cx - slot / 2} y={pad} width={slot} height={H - pad * 2} fill="transparent" />
            <line x1={cx} x2={cx} y1={y(c.high)} y2={y(c.low)} stroke={color} strokeWidth={1.5} />
            <rect x={cx - bodyW / 2} y={Math.min(y(c.open), y(c.close))} width={bodyW}
              height={Math.max(2, Math.abs(y(c.open) - y(c.close)))} fill={color}
              stroke={(isCorrect || isPicked) ? "#F8FAFC" : "none"} strokeWidth={isCorrect || isPicked ? 1.5 : 0} rx={1} />
          </g>
        );
      })}
    </svg>
  );
}
